import { createContext } from "react";

import { type ReportItemType } from "../interfaces";
import { type KnownFields } from "shared/known-fields.enum";

interface ReportContextType {
  report: ReportItemType[];
  setReport: (report: ReportItemType[]) => void;
  setRawReportData: (report: string[][]) => void;
  rawReportData: string[][];
  mappings: KnownFields[];
  setMappings: (mappings: KnownFields[]) => void;
  uploads: number;
  setUploads: (uploads: number) => void;
}

export const ReportContext = createContext<ReportContextType>({
  report: [],
  rawReportData: [],
  setReport: () => {},
  setRawReportData: () => {},
  mappings: [],
  setMappings: () => {},
  uploads: 0,
  setUploads: () => {},
});
